import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import classNames from "classnames";

const Container = styled.div.attrs({ className: "dmt-toggle" })`
  border: 1px solid;
  border-radius: 0.25rem;
  border-color: #b21f2d;
  cursor: pointer;
  display: inline-block;
  height: 36px;
  overflow-x: hidden;
  position: relative;
  width: 98px;

  &.on {
    border-color: #28a745;
  }

  .on-button,
  .off-button {
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    height: 100%;
    width: 100%;
    transition: left 0.3s;
  }
  .on-button {
    background: #28a745;
    left: -98px;
    padding: 0 13px 0 0;
  }
  &.on .on-button {
    left: 0;
  }
  .off-button {
    background: #bd2130;
    padding: 0 0 0 13px;
    left: 0;
  }
  &.on .off-button {
    left: 98px;
  }

  .toggle {
    background: #fff;
    border-radius: 0.25rem;
    height: 100%;
    width: 13px;
    top: 0;
    left: 0;
    position: absolute;
    z-index: 1;
    transition: left 0.3s;
  }
  &.on .toggle {
    left: 85px;
  }
`;

const DMTToggle = ({ onText, offText, active, className, ...props }) => {
  return (
    <Container className={classNames(className, { on: active })} {...props}>
      <div className="on-button">{onText}</div>
      <div className="toggle" />
      <div className="off-button">{offText}</div>
    </Container>
  );
};

DMTToggle.propTypes = {
  onText: PropTypes.string,
  offText: PropTypes.string,
  active: PropTypes.bool
};

DMTToggle.defaultProps = {
  onText: "Enabled",
  offText: "Disabled",
  active: true
};

export default DMTToggle;
